module.exports = __webpack_public_path__ + "static/media/bgMusic.f7938d5e.mp3";